import React from 'react';
import { Stethoscope } from 'lucide-react';
import { Input } from '../ui/Input';
import { Textarea } from '../ui/Textarea';
interface WorkerHealthFieldsProps {
  nextVisitDate?: string;
  notes?: string;
  onChange: (changes: {
    nextVisitDate?: string;
    notes?: string;
  }) => void;
}
export function WorkerHealthFields({
  nextVisitDate,
  notes,
  onChange
}: WorkerHealthFieldsProps) {
  return <section data-id="element-2000" data-mp="oqcjlf5z233f">
      <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-2001" data-mp="oqm80ybdc270">
        <Stethoscope className="h-4 w-4" data-id="element-2002" data-mp="sq3hs3xtvlhz" /> Sorveglianza sanitaria
      </h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2003" data-mp="xhuylmr6mcux">
        <Input label="Data prossima visita" type="date" value={nextVisitDate || ''} onChange={e => onChange({
        nextVisitDate: e.target.value
      })} data-id="element-2004" data-mp="xkh6xolwcwe7" />
        <div className="col-span-full" data-id="element-2005" data-mp="17ehhw73v0vuu">
          <Textarea label="Note" placeholder="Eventuali note sulla sorveglianza sanitaria..." value={notes || ''} onChange={e => onChange({
          notes: e.target.value
        })} data-id="element-2006" data-mp="1cem1w73z88pt" />
        </div>
      </div>
    </section>;
}